<br>
<div>
    <div class="textBlock">
        <div>
            <p class="h2 text-center">Einde</p>
            <hr>
        </div>
        <div>
            <div class="text-center">
                <p class="h4 text-center">
                    Bedankt!
                </p>
                <hr>
                <p class="text-center d-block margin">
                    D-A-N-K-U, Danku! Hopelijk hebben jullie genoten van deze tocht door onze Chiro omgeving.            
                </p>
                <p class="text-center d-block margin">
                    Vergeet zeker niet om uw bestelde bierboxen en/of maaltijden te komen afhalen op de aangegeven momenten! <br>Meer info kan u vinden op <a href="www.chirobloemendaal.be">onze website</a>.        
                </p>
                <img src="http://www.chirobloemendaal.be/images/fwe2021.jpg" alt="Feestweekendposter.jpg">
            </div>
        </div>
    </div>
</div>